// Change #100463 - where a licence stands, using the same window the server's
// access check uses (started, renewal grace not passed, not ended). Dates are
// "Y-m-d H:i:s" in the app's own time, so compare as strings against a local
// timestamp in the same format.

const pad = (n) => String(n).padStart(2, "0");
export const nowStamp = () => {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(
    d.getMinutes()
  )}:${pad(d.getSeconds())}`;
};

/** "active" | "grace" | "lapsed" | "ended" | "future" */
export const licenceState = (l, now = nowStamp()) => {
  if (l?.EndDateTime && String(l.EndDateTime) <= now) return "ended";
  if (l?.StartDateTime && String(l.StartDateTime) > now) return "future";
  if (l?.RenewalGraceDateTime && String(l.RenewalGraceDateTime) < now) return "lapsed";
  if (l?.RenewalDateTime && String(l.RenewalDateTime) < now) return "grace";
  return "active";
};

/** Paid up: gives access today. */
export const isLivePaid = (l, now) => ["active", "grace"].includes(licenceState(l, now));

export const STATE_BADGE = {
  active: { cls: "badge-soft-success", text: "Active" },
  grace: { cls: "badge-soft-warning", text: "Renewal due" },
  lapsed: { cls: "badge-soft-danger", text: "Lapsed" },
  ended: { cls: "badge-soft-secondary", text: "Ended" },
  future: { cls: "badge-soft-info", text: "Starts later" },
};
